import { render, staticRenderFns } from "./HeaderLayout.vue?vue&type=template&id=678af200&scoped=true"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"
import style0 from "./HeaderLayout.vue?vue&type=style&index=0&id=678af200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678af200",
  null
  
)

export default component.exports